var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsNumber } from 'class-validator';
import { D2CRefundPolicyRuleCriterion, D2CRefundPolicyRuleRefundChargeUnit, D2CRefundPolicyRuleTimeUnit, } from '../../../enums';
export class CreateD2CRefundPolicyRuleDto {
}
__decorate([
    IsEnum(D2CRefundPolicyRuleCriterion),
    __metadata("design:type", String)
], CreateD2CRefundPolicyRuleDto.prototype, "criterion", void 0);
__decorate([
    IsEnum(D2CRefundPolicyRuleTimeUnit),
    __metadata("design:type", String)
], CreateD2CRefundPolicyRuleDto.prototype, "timeUnit", void 0);
__decorate([
    IsNumber({}, { message: '시간 기준을 입력해주세요.' }),
    __metadata("design:type", Number)
], CreateD2CRefundPolicyRuleDto.prototype, "timeValue", void 0);
__decorate([
    IsEnum(D2CRefundPolicyRuleRefundChargeUnit),
    __metadata("design:type", String)
], CreateD2CRefundPolicyRuleDto.prototype, "refundChargeUnit", void 0);
__decorate([
    IsNumber({}, { message: '환불 수수료를 입력해주세요.' }),
    __metadata("design:type", Number)
], CreateD2CRefundPolicyRuleDto.prototype, "refundChargeValue", void 0);
